import {
  FIELDALLOWANCEREQUESTORDER_ALL,
  FIELDALLOWANCEREQUESTORDER_GET,
  FIELDALLOWANCEREQUESTORDER_PUT,
  FIELDALLOWANCEREQUESTORDER_DEL,
  FIELDALLOWANCEREQUESTORDER_POST,
  FIELDALLOWANCEREQUESTORDER_LOADING,
  FIELDALLOWANCEREQUESTORDER_ERROR,
  FIELDALLOWANCEREQUESTORDER_PENDING_COUNT,
} from '../../actions/types';

const initialState = {
  isLoading: true,
  isCompleted: true,
  pendingCount: 0,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case FIELDALLOWANCEREQUESTORDER_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case FIELDALLOWANCEREQUESTORDER_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case FIELDALLOWANCEREQUESTORDER_PENDING_COUNT:
      return { ...state, pendingCount: action.payload };
    case FIELDALLOWANCEREQUESTORDER_ALL:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case FIELDALLOWANCEREQUESTORDER_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case FIELDALLOWANCEREQUESTORDER_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case FIELDALLOWANCEREQUESTORDER_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case FIELDALLOWANCEREQUESTORDER_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case 'FIELD_ALLOWANCE_REQUEST_ORDER_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
